import { Typography } from 'antd';
import UtilString from '../../utils/UtilString';

const { Text } = Typography;

const MyTextSecondary = ({
  bold,
  style,
  color,
  strong,
  children,
  size = 14,
  className = UtilString.EMPTY_STRING,
  ...otherProps
}) => {
  return (
    <Text
      className={className}
      style={{
        fontSize: size,
        fontWeight: bold ? 'bold' : 'normal',
        color: color || 'var(--ant-color-text-secondary)',
        ...style,
      }}
      strong={strong || false}
      {...otherProps}
    >
      {children}
    </Text>
  );
};

export default MyTextSecondary;
